import * as React from 'react';
import { ISelectProps } from '../Select';
import { IOption, ISelectDropdownActions, TOptionValue } from '../types';

interface ISelectStateControllerProps extends ISelectProps<TOptionValue | TOptionValue[]> {
  actions: ISelectDropdownActions;
  focusedIndex: number;
}

export const useSelectStateController = (props: ISelectStateControllerProps) => {
  const [selectedItems, setSelectedItems] = React.useState<TOptionValue[]>(initialSelectedItems(props.value));

  const selectOptionMultiple = (newValue: TOptionValue) => {
    const { onChange } = props;

    const found = selectedItems.find(item => item === newValue);
    const newSelectedItems: TOptionValue[] = found
      ? selectedItems.filter(item => item !== found)
      : selectedItems.concat(newValue);

    setSelectedItems(newSelectedItems);

    if (onChange) {
      onChange(newSelectedItems);
    }
  };

  const selectOptionSingle = (newValue: TOptionValue) => {
    const { onChange } = props;

    setSelectedItems([newValue]);
    props.actions.closeDropdown();

    if (onChange) {
      onChange(newValue);
    }
  };

  const selectOption = ({ value }: IOption) => {
    const { allowEmpty, multiple } = props;

    if (!allowEmpty && selectedItems.length <= 1 && selectedItems.includes(value)) {
      return;
    }

    if (multiple) {
      selectOptionMultiple(value);
    } else {
      selectOptionSingle(value);
    }
  };

  const toggleFocusedOptionState = () => {
    const option = props.options.find((_, index) => index === props.focusedIndex);

    if (option) {
      selectOption(option);
    }
  };

  return { selectedItems, selectOption, toggleFocusedOptionState };
};

function initialSelectedItems(value: TOptionValue | TOptionValue[]) {
  if (value === undefined) {
    return [];
  }

  return Array.isArray(value) ? value : [value];
}
